<template>
  <div class="roles-management-page">
    <div class="container-fluid py-4">
      <div class="card shadow">
        <div class="card-body">
          <RolesTable />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RolesTable from '@/components/RolesTable.vue';

export default {
  name: 'RolesManagement',
  components: {
    RolesTable
  }
};
</script>

<style scoped>
.roles-management-page {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.card {
  border-radius: 0.5rem;
  border: none;
}
</style> 